<template style="position: fixed">
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="miniValue"
    permanent
    fixed
    dark
    width="300"
    app
  >
    <v-app-bar
      v-if="navbarLogo"
      :dense="toolbarDense"
      dark
      class="logo-nav"
      @click.stop.prevent=""
    >
      <v-toolbar-title class="text-left">
        <v-avatar tile class="company-logo-mini" v-if="miniValue">
          <img
            src="../../assets/minBe.png"
            alt="BirchEquipment-logo"
            @click="navigateHome"
          />
        </v-avatar>
        <v-avatar tile class="company-logo" v-else>
          <v-row no-gutters>
            <v-col cols="12" class="column mt-12">
              <img
                src="../../assets/logo-BirchEquipment-old.png"
                alt="birchEquipment-logo"
                @click="navigateHome"
              />
            </v-col>
            <!-- <v-col cols="12" class="column">
              <div class="pro-serv-heading ml-10">Pro Serv Portal</div>
            </v-col> -->
          </v-row>
        </v-avatar>
      </v-toolbar-title>
    </v-app-bar>
    <the-layout-drawer-list
      :mini="miniValue"
      :dense="navbarDense"
      :routes="routesPath"
      icon-show
    />
    <span class="powered-by">
      <v-footer bottom permanent fixed class="footer">
        <div class="font-size-change">
          Last Login : {{ lastLoginTime | formattoLocalDate }}
        </div>
      </v-footer></span
    >
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import TheLayoutDrawerList from "./TheLayoutDrawerList.vue";
import { adminRoutes } from "../../config/admin.route.config";
//import  { constantRoutes } from '@/router';
import EventBus from "../../utils/EventBus";
import moment from "moment";

// BE-1121: Access Control is a top-level section. "Access Control" is a real
// permission now (User Management's checkbox list, and the hardcoded lists in
// the user store) -- but only Customers actually carry stored permissions:
// src/store/modules/user.js discards them for Admin and Birch User and hands
// out the hardcoded list every login, so the checkbox only grants and revokes
// for Customers. Users provisioned before this release hold no such key, hence
// the migration fallback in hasAccessControlAccess(). "Access Control Codes" is
// also a stored key, so renaming that child hides a screen.
const ACCESS_CONTROL_SECTION = "Access Control";
const SETTINGS_SECTION = "Settings";
const ACCESS_CONTROL_CODES = "Access Control Codes";
const ACCESS_CONTROL_SETUP = "Access Control Setup";
const ACCESS_CONTROL_OPERATORS = "Access Control Operators";
const JOBSITE_ACCESS_CODES = "Jobsite Access Codes";
const ACCESS_CONTROL_CUSTOMER_SCOPED = [
  ACCESS_CONTROL_OPERATORS,
  JOBSITE_ACCESS_CODES,
];
// Which menu entry entitles each path under the section. The operator forms sit
// on their own paths but are governed by the Operators entry; operator-groups is
// listed before operators so the longer prefix is considered first.
const AC_SCREEN_OWNERS = [
  ["/access-control/codes", ACCESS_CONTROL_CODES],
  ["/access-control/operator-groups", ACCESS_CONTROL_OPERATORS],
  ["/access-control/operators", ACCESS_CONTROL_OPERATORS],
  ["/access-control/jobsites", JOBSITE_ACCESS_CODES],
  ["/access-control/setup", ACCESS_CONTROL_SETUP],
];

export default {
  name: "TheLayoutDrawer",
  props: {
    miniValue: { type: Boolean, default: true },
  },
  components: {
    TheLayoutDrawerList,
  },
  data: () => ({
    routesPath: [],
    color: "dark",
    permissionsArrayFinal: [],
    drawer: true,
    mini: true,
  }),
  watch: {
    miniValue() {
      EventBus.$emit("mini", this.miniValue);
    },
    companyIdDropdown(newVal) {
      // React to changes in companyIdDropdown
      if (this.roles === "Customer") {
        this.updateRoutesBasedOnCompany(newVal);
      }
    },
  },
  computed: {
    ...mapGetters([
      "companyIdDropdown",
      "navbarDense",
      "navbarShow",
      "navbarLogo",
      "toolbarDense",
      "roles",
      "lastLoginTime",
      "showSMSLeftNav",
      "permissions",
      "smsUserPermissions",
    ]),
  },
  created() {
    this.getPermissions();
    this.permissionsArrayFinal = [];
    this.permissionsArrayFinal = this.permissions;
    let cloneAdminRoutes = [];

    if (this.roles == "Admin" || this.roles == "Birch User") {
      this.permissionsArrayFinal = this.permissions;
      this.permissionsArrayFinal.push("Existing Active Alerts");
      // }
    } else if (this.roles == "Customer") {
      // new logic
      this.permissionsArrayFinal = this.permissionsArrayFinal.filter(
        (e) => e != "Existing Active Alerts"
      );
    }
    // BE-1121: menu permissions are a flat list of names. The section's own
    // name is granted like any other, but accounts created before this release
    // do not have it, so hasAccessControlAccess() falls back to what Settings
    // would have shown them and the name is synthesised here for the top-level
    // filter below.
    if (
      this.hasAccessControlAccess() &&
      this.permissionsArrayFinal.indexOf(ACCESS_CONTROL_SECTION) === -1
    ) {
      this.permissionsArrayFinal = [
        ...this.permissionsArrayFinal,
        ACCESS_CONTROL_SECTION,
      ];
    }

    cloneAdminRoutes = adminRoutes;
    let adminRoutesWithPermissions = cloneAdminRoutes.filter(
      (item) => this.permissionsArrayFinal.indexOf(item.name) !== -1
    );

    // console.log(adminRoutesWithPermissions);
    let filteredAdminRoutes = [];
    if (
      adminRoutesWithPermissions.filter((item) => item.name == "Reports")[0] !=
      undefined
    ) {
      let reportsChildRoutes = adminRoutesWithPermissions
        .filter((item) => item.name == "Reports")[0]
        .children.filter(
          (item) => this.permissionsArrayFinal.indexOf(item.name) !== -1
        );

      filteredAdminRoutes = adminRoutesWithPermissions.map((x) => {
        if (x.name == "Reports") {
          x.children = reportsChildRoutes;
        }
        return x;
      });
    }

    // access control modes
    else {
      filteredAdminRoutes = adminRoutesWithPermissions;
    }
    this.routesPath = this.filterAsyncRoutes(this.roles, filteredAdminRoutes);

    this.applyAccessControlVisibility();
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "DD/MM/YYYY hh:mm:ss A";
        // return moment(value).format(format);
        return moment.utc(value).local().format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  mounted() {},
  methods: {
    // Operators and Jobsite Codes are only meaningful for a customer that has
    // access control switched on, so the section is rebuilt whenever the
    // toolbar customer changes.
    updateRoutesBasedOnCompany() {
      this.applyAccessControlVisibility();
    },
    customerHasAccessCodes() {
      if (this.roles !== "Customer") return true;
      const enabledFor = (this.$store.getters.customerAccessCodes || []).map(
        (c) => c.customerId
      );
      return enabledFor.includes(this.companyIdDropdown);
    },
    hasAccessControlAccess() {
      // Granted outright -- the normal path once a user has been saved since
      // this release, because User Management now offers the checkbox.
      if (this.permissionsArrayFinal.indexOf(ACCESS_CONTROL_SECTION) !== -1) {
        return true;
      }
      // Migration path for users provisioned before the section existed: show
      // exactly what the Settings menu would have shown them, and no more.
      // Without the Settings check this would hand the section to customers who
      // were never given access to the screens inside it.
      // Self-healing: saving a customer user in User Management writes the real
      // key, after which this branch is never consulted for them. Drop it once
      // every customer user has been re-saved.
      if (this.permissionsArrayFinal.indexOf(SETTINGS_SECTION) === -1) {
        return false;
      }
      return (
        this.permissionsArrayFinal.indexOf(ACCESS_CONTROL_CODES) !== -1 ||
        this.customerHasAccessCodes()
      );
    },
    allowedAccessControlChildren() {
      const allowed = [];
      if (this.permissionsArrayFinal.indexOf(ACCESS_CONTROL_CODES) !== -1) {
        allowed.push(ACCESS_CONTROL_CODES);
      }
      // Setup carries the Birch master code, so it is gated on role alone
      // (Admin / Birch User, per the route meta) rather than on a permission a
      // customer could hold.
      allowed.push(ACCESS_CONTROL_SETUP);
      if (this.customerHasAccessCodes()) {
        allowed.push(...ACCESS_CONTROL_CUSTOMER_SCOPED);
      }
      return allowed;
    },
    // Rebuilt from the route config rather than mutated in place: adminRoutes is
    // a module-level singleton, so filtering its children would drop them for
    // the rest of the session and they would never come back on a re-entitled
    // customer.
    applyAccessControlVisibility() {
      const source = adminRoutes.find((e) => e.name === ACCESS_CONTROL_SECTION);
      if (!source) return;
      const allowed = this.allowedAccessControlChildren();
      // Gated here rather than on the insert branch: the section is rebuilt on
      // every customer change, and a guard on one branch only would let an
      // unentitled user back in the moment the section had to be re-inserted.
      const children = this.hasAccessControlAccess()
        ? (source.children || []).filter(
            (child) =>
              allowed.includes(child.name) &&
              child.meta.roles.includes(this.roles)
          )
        : [];
      const at = this.routesPath.findIndex(
        (e) => e.name === ACCESS_CONTROL_SECTION
      );

      if (!children.length) {
        // Splice rather than reassign: TheLayoutDrawerList snapshots the routes
        // prop into data once and never watches it, so a new array identity
        // never reaches the menu -- the entries would stay on screen for a
        // customer who is no longer entitled to them.
        if (at > -1) this.routesPath.splice(at, 1);
      } else if (at > -1) {
        this.routesPath[at].children = children;
      } else {
        const restored = { ...source, children };
        const precedingNames = adminRoutes
          .slice(0, adminRoutes.indexOf(source))
          .map((r) => r.name);
        let insertAt = 0;
        this.routesPath.forEach((r, i) => {
          if (precedingNames.includes(r.name)) insertAt = i + 1;
        });
        this.routesPath.splice(insertAt, 0, restored);
      }

      this.leaveAccessControlIfOpen(children);
    },
    // Leaving a screen the user just lost. Checked per screen, not only when the
    // whole section goes: a customer can keep Access Codes while losing
    // Operators, and would otherwise sit on Operators refetching another
    // customer's data. Reads the pending route first because in created() the
    // destination has not been committed to $route yet.
    leaveAccessControlIfOpen(children) {
      const pending =
        this.$router.history && this.$router.history.pending
          ? this.$router.history.pending.path
          : null;
      const current = pending || (this.$route && this.$route.path);
      if (!current || !current.startsWith("/access-control")) return;
      // The operator and operator-group forms have their own paths but are
      // reached through, and entitled by, the Operators entry -- matching child
      // paths exactly would throw an entitled user off a form mid-edit. An
      // unrecognised /access-control path is left alone rather than bounced.
      const owner = AC_SCREEN_OWNERS.find(
        ([prefix]) => current === prefix || current.startsWith(prefix + "/")
      );
      if (!owner) return;
      const stillAllowed = (children || []).some(
        (child) => child.name === owner[1]
      );
      if (!stillAllowed) {
        this.navigateHome();
      }
    },
    getPermissions() {
      this.permissionsArrayFinal = [];
      this.permissionsArrayFinal = this.permissions;
    },
    stateNavbarShow(state) {
      this.$store.dispatch("NavbarState", { state });
    },
    navigateHome() {
      this.$router.push("/");
    },
    hasPermission(role, route) {
      if (route.meta && route.meta.roles) {
        return route.meta.roles.includes(role);
      }
      return true;
    },

    filterAsyncRoutes(roles, routes) {
      const res = [];
      routes.forEach((route) => {
        const tmp = { ...route };
        if (this.hasPermission(roles, tmp)) {
          if (tmp.children) {
            tmp.children = this.filterAsyncRoutes(roles, tmp.children);
          }

          //Logic to show create planning sheet in the left navigation only if user has 'createPlanningSheets' permission
          if (tmp.name === "Create Planning Sheet") {
            if (
              this.smsUserPermissions &&
              this.smsUserPermissions.createPlanningSheets
            ) {
              res.push(tmp);
            }
          } else {
            res.push(tmp);
          }
        }
      });
      return res;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/variables.scss";
.v-list-item__title {
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
  font-weight: 400 !important;
  font-size: 16px !important;
}
.font-size-change {
  font-size: 12px !important;
  position: relative;
  top: -5px;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px;
}
.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  margin-left: 4px;
  height: 52px;
  padding: 16px 32px;
  display: flex;
  align-items: center;
}
.mdi {
  font-size: 35px !important;
}
a.v-list-item--active.v-list-item.v-list-item--link.theme--dark {
  height: 52px;
  padding: 16px 32px;
  display: flex;
  align-items: center;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin: 0;
  margin-right: 16px;
}
.v-list--dense .v-list-item .v-list-item__content {
  padding: 0;
  padding-top: 5px;
}
.navigation-icon {
  color: #fff !important;
}
.company-logo-mini {
  width: 48px !important;
  height: 48px !important;
}
.company-logo-mini img {
  width: auto;
  height: 24px;
  cursor: pointer;
}
.company-logo img {
  height: 75px;
  width: auto;
  cursor: pointer;
}

.v-toolbar__content {
  text-align: center;
}
.v-toolbar__title {
  width: 100%;
}

.company-logo .column {
  width: 100% !important;
}
.pro-serv-heading {
  font-size: 14px;
  color: #f7402f;
  font-weight: 500;
  margin-top: -10px;
}
.footer {
  background-color: $black-shade-2 !important;
}
</style>
